exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-facial-photo-wrapper[data-v-04b01408]{overflow:hidden}.standard-info[data-v-04b01408]{display:flex;flex-direction:column;align-items:center}.standard-info div[data-v-04b01408]{padding:20px;border:1px solid #e0e0e0}.standard-info img[data-v-04b01408]{width:920px;height:auto}.standard-info p[data-v-04b01408]{font-size:medium;line-height:30px}.upload-bezel[data-v-04b01408],.upload-bezel div[data-v-04b01408]:first-child{display:flex;flex-direction:column;align-items:center}.upload-bezel div[data-v-04b01408]:first-child{margin-top:20px;padding:20px;width:920px;border:1px solid #e0e0e0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-04b01408&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UserManage/UserManage/UploadFacialPhoto.vue
// module id = 430
// module chunks = 0